import { render, staticRenderFns } from "./shopDetails.vue?vue&type=template&id=ae6d8af4&"
import script from "./shopDetails.vue?vue&type=script&lang=js&"
export * from "./shopDetails.vue?vue&type=script&lang=js&"
import style0 from "./shopDetails.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports